/**
 * ESM face of @quickstock/shared.
 *
 * The implementation stays CommonJS because `backend/` is CommonJS and is packaged
 * into an Electron installer, where introducing a build step buys nothing and
 * risks the shipping artefact. This wrapper lets the ESM consumers in `pwa/`
 * import named bindings without a bundler-specific workaround.
 *
 * Bindings are re-exported explicitly rather than by destructuring so that every
 * bundler can see them statically. Rollup in particular will not infer named
 * exports from a CommonJS module that sits outside node_modules, which is exactly
 * where a linked workspace package lands.
 *
 * Adding an export here means adding it in index.js too. The test suite imports
 * through both faces to keep them honest.
 */

import shared from './index.js';

export const getEffectiveUnitPrice = shared.getEffectiveUnitPrice;
export const calculateAggregatedLineTotals = shared.calculateAggregatedLineTotals;
export const formatCurrency = shared.formatCurrency;
export const createStoreTime = shared.createStoreTime;
export const formatLeft = shared.formatLeft;
export const formatRight = shared.formatRight;
export const formatCenter = shared.formatCenter;
export const calculateLineLength = shared.calculateLineLength;
export const getLineSeparators = shared.getLineSeparators;
export const sanitisePrintable = shared.sanitisePrintable;
export const sanitiseString = shared.sanitiseString;

export default shared;
